import React from "react";
import {Product} from "depoto-core";
import {formatPrice} from "../utils";
import './ProductStockColumn.css'
import {useCore} from "../hooks";
import {ModalStockOverview} from "./ModalStockOverview";

type Props = {
  product: Product
}
export const ProductStockColumn: React.FC<Props> = ({ product }) => {
  const { currency, checkouts, selectedCheckoutId } = useCore()
  const checkoutDepotIds = checkouts
    .find(c => c.id === selectedCheckoutId)
    ?.depots?.map(d => d.id) || []
  const depotIdsSet = new Set(checkoutDepotIds)

  const scopedQuantities = checkoutDepotIds.length && Array.isArray(product?.quantities)
    ? product.quantities.filter((q: any) => depotIdsSet.has(q?.depot?.id))
    : []

  const hasScopedQuantities = scopedQuantities.length > 0
  const quantityStock = hasScopedQuantities
    ? scopedQuantities.reduce((sum: number, q: any) => sum + Number(q?.quantityStock || 0), 0)
    : Number(product?.quantityStock || 0)
  const quantityReservation = hasScopedQuantities
    ? scopedQuantities.reduce((sum: number, q: any) => sum + Number(q?.quantityReservation || 0), 0)
    : Number(product?.quantityReservation || 0)
  const quantityAvailable = hasScopedQuantities
    ? scopedQuantities.reduce((sum: number, q: any) => sum + Number(q?.quantityAvailable || 0), 0)
    : Number(product?.quantityAvailable || 0)

  return (
    <div className="mr-2 flex flex-col justify-center">
      <ModalStockOverview
        product={product}
        quantityStock={quantityStock}
        quantityReservation={quantityReservation}
        quantityAvailable={quantityAvailable}
      />
      <div className="sell-price font-bold">
        {formatPrice(product?.sellPrice, currency.id)}
      </div>
    </div>
  )
}
